import { Form } from "@/components/core/forms/form.tsx";
import { FormDescription, FormField, FormGroup, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form.tsx";
import userService from "@/features/dashboard/api/services/user-service";
import { useNavigate } from "@tanstack/react-router";
import moment from "moment";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { Button } from "./core/buttons/button";
import { Input } from "./core/forms/input";
import Select from "./core/forms/select";
import { useModalControl } from "./core/modals/use-modal-controller";

export default function ConfirmWithPasswordModal({
	onSubmit,
}: {
	onSubmit: (values: any) => void;
}) {
	const { closeModal } = useModalControl();
	const navigate = useNavigate();
	const [error, setError] = useState(null);
	const form = useForm({
		defaultValues: {
			password: null,
		},
	});

	const handleSubmit = async (values) => {
		const response = await userService.validatePassword(values.password);
		if (response.message === "Valid") {
			setError(null);
			sessionStorage.setItem("password_entered_at", moment());
			onSubmit();
			closeModal();
		} else {
			setError(response.message);
			toast.error("Invalid pin code. Please try again.");
		}
	};

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(handleSubmit)}>
				<div className="grid grid-cols-12 w-full gap-3 py-3">
					<div className="col-span-12 w-full">
						<FormField
							control={form.control}
							name="password"
							render={({ field }) => (
								<FormItem>
									<div className="flex flex-col w-full">
										<FormLabel required>Pin Code</FormLabel>
										<FormDescription>Enter your pin code to confirm and proceed with the submission.</FormDescription>
									</div>
									<FormGroup>
										<Input autoComplete="off" type="password" {...field} />
									</FormGroup>
									{error && <FormMessage>{error}</FormMessage>}
								</FormItem>
							)}
						/>
					</div>
				</div>
				<div className="flex flex-row justify-between w-full gap-4 mt-4">
					<Button
						type="button"
						className=""
						variant="ghost"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>

					<Button className="" variant="default" disabled={form.formState.isSubmitting}>
						Confirm
					</Button>
				</div>
			</form>
		</Form>
	);
}
